import type { CityConfig } from "../city-template/types";

export const everettConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Everett",
  state: "Washington",
  stateAbbr: "WA",
  slug: "everett",
  route: "/cities/everett",
  title: "Emergency Passport Everett WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Everett, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Everett, Lynnwood, Marysville, and all Snohomish County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Everett, WA",
  heroSubtitle: "Everett travelers — from Boeing assembly plant workers to Naval Station Everett sailors to Snohomish County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Snohomish County and the north Puget Sound region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Everett%20Washington%20with%20the%20massive%20Boeing%20assembly%20plant%2C%20Port%20of%20Everett%20waterfront%20with%20marina%20and%20Navy%20ships%2C%20the%20Everett%20skyline%20with%20modern%20buildings%20against%20the%20backdrop%20of%20Puget%20Sound%20and%20the%20Olympic%20Mountains%2C%20lush%20evergreen%20surroundings%2C%20Snohomish%20River%20delta%2C%20warm%20golden%20afternoon%20light%2C%20Pacific%20Northwest%20maritime%20and%20industrial%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=everett-hero-001&orientation=landscape",
  heroImageAlt: "Everett Washington Boeing assembly plant and Port of Everett waterfront",
  geoPosition: "47.9789;-122.2021",
  geoPlacename: "Everett, Washington",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "Approximately 28 miles south of Everett via I-5",
  },
  nearbyCitiesZips: [
    { name: "Everett", zips: "98201, 98203, 98204, 98205, 98206, 98207, 98208, 98213" },
    { name: "Lynnwood", zips: "98036, 98037, 98046, 98087" },
    { name: "Marysville", zips: "98270, 98271" },
    { name: "Mukilteo", zips: "98275" },
    { name: "Mill Creek", zips: "98012, 98082" },
    { name: "Edmonds", zips: "98020, 98026" },
    { name: "Lake Stevens", zips: "98258" },
    { name: "Snohomish", zips: "98290, 98291, 98296" },
    { name: "Monroe", zips: "98272" },
    { name: "Mountlake Terrace", zips: "98043" },
    { name: "Bothell", zips: "98011, 98012, 98021, 98041" },
    { name: "Arlington", zips: "98223" },
    { name: "Stanwood", zips: "98292" },
    { name: "Granite Falls", zips: "98252" },
    { name: "Sultan", zips: "98294" },
    { name: "Clearview", zips: "98296" },
    { name: "Maltby", zips: "98296" },
    { name: "Silver Firs", zips: "98296" },
    { name: "Silvana", zips: "98287" },
    { name: "Tulalip", zips: "98271" },
    { name: "Camano Island", zips: "98282" },
    { name: "Whidbey Island", zips: "98260" },
    { name: "Langley", zips: "98260" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 30 minutes south via I-5" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-anchor-line", title: "Boeing & Naval Station Hub", desc: "Serving Boeing Everett Factory, Naval Station Everett, and Snohomish County travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Snohomish County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/cities/seattle" },
    { name: "Emergency passport help in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Urgent passport services in Tacoma, WA", route: "/cities/tacoma" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Everett, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 30 minutes south via I-5. Everett residents can ship from any UPS or FedEx in Snohomish County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Everett, Lynnwood, Marysville, Mukilteo, Mill Creek, Lake Stevens, Snohomish, Monroe, and all of Snohomish County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Everett and Snohomish County. From the Boeing Everett Factory, the largest building in the world by volume, to Naval Station Everett on the Puget Sound waterfront, from the retail corridor along Everett Mall Way to the residential communities of Silver Lake and the Snohomish River Valley — we serve all of Everett and Snohomish County.",
  nearbyCitiesIntro: "We serve Everett and all nearby communities including Lynnwood, Marysville, Mukilteo, Mill Creek, Edmonds, Lake Stevens, Snohomish, Monroe, Mountlake Terrace, Bothell, Arlington, Stanwood, Granite Falls, Sultan, and the Tulalip Tribes reservation. We also serve Camano Island, Whidbey Island, and Island County.",
  howItWorksIntro: "Most Everett travelers complete everything online and ship documents overnight. No need to drive 30+ minutes south on I-5 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Everett is the seat of Snohomish County and home to the Boeing assembly plant and Naval Station Everett — two major sources of international travel. Here are the most common passport mistakes we see from Snohomish County travelers.",
  testimonialsIntro: "Everett travelers — from Boeing assembly workers to Navy families to Snohomish County residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Everett, WA? Here are the most common ones we hear from Snohomish County travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 30+ minutes to Seattle on I-5", "Parking and traffic in downtown Seattle"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "No I-5 traffic or downtown parking hassle", "Perfect for Boeing and Navy travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Everett travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency. Perfect for Boeing business travel, Navy deployments, and Snohomish County family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — I-5 corridor courier", "Boeing and Navy travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Everett adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Snohomish County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Everett residents and families — including Boeing families, Navy families, and Snohomish County residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Everett residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Everett and Snohomish County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Everett and Snohomish County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Everett WA", description: "Urgent passport processing for Everett Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Everett WA", description: "Fast passport renewal for Everett Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Everett WA", description: "New passport application services for Everett Washington residents applying for their first passport." },
    { name: "Child Passport Everett WA", description: "Minor passport services for Everett Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "PO2 Rodriguez",
      location: "Naval Station Everett, WA",
      rating: 5,
      text: "Deployment orders with 5 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Evergreen Way and the whole process was seamless. Outstanding for military families.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Karen H.",
      location: "Lake Stevens, WA",
      rating: 5,
      text: "Family trip to Mexico with 8 days notice. Four passports — two adult renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Everett Mall Way and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tom W.",
      location: "Mukilteo, WA",
      rating: 5,
      text: "Business trip to Seoul with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for Snohomish County.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa M.",
      location: "Everett, WA",
      rating: 5,
      text: "Lost my passport the week before a trip to London. Fast Passport Center replaced it in 48 hours. With Paine Field just 10 minutes away for connections, I was ready to fly. Incredible service.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "evt-1",
      name: "Everett Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3102 Hoyt Ave",
      city: "Everett",
      state: "WA",
      zip: "98201",
      phone: "(425) 259-1421",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Everett, near the Snohomish County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Everett acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Everett and Naval Station Everett.",
      icon: "ri-mail-line",
    },
    {
      id: "evt-2",
      name: "Lynnwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6817 208th St SW",
      city: "Lynnwood",
      state: "WA",
      zip: "98036",
      phone: "(425) 771-1313",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lynnwood, approximately 10 miles south of downtown Everett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Lynnwood, south Everett, and Mukilteo residents. Ample parking available near Alderwood Mall.",
      icon: "ri-mail-line",
    },
    {
      id: "evt-3",
      name: "Marysville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4207 88th St NE",
      city: "Marysville",
      state: "WA",
      zip: "98270",
      phone: "(360) 659-3511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Marysville, approximately 7 miles north of downtown Everett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marysville, Tulalip, and north Snohomish County communities. Good alternative for north-county travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "evt-4",
      name: "Mill Creek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15822 Mill Creek Blvd",
      city: "Mill Creek",
      state: "WA",
      zip: "98012",
      phone: "(425) 338-6121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Mill Creek, approximately 8 miles southeast of downtown Everett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Mill Creek, Bothell, and southeast Snohomish County residents. Quiet suburban location with easy parking.",
      icon: "ri-mail-line",
    },
    {
      id: "evt-5",
      name: "Snohomish County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "3000 Rockefeller Ave, M/S 605",
      city: "Everett",
      state: "WA",
      zip: "98201",
      phone: "(425) 388-3466",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Everett Snohomish County Courthouse",
      website: "https://www.snohomishcountywa.gov/",
      websiteLabel: "Snohomish County",
      notes: "Snohomish County Clerk passport acceptance. Extended hours compared to post office. Convenient to downtown Everett. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-5 traffic to downtown Seattle", fpc: "No — ship from Everett" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Boeing & Navy Advantage", agency: "No special guidance", fpc: "Yes — aerospace and military travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Everett Boeing employees and Navy families often discover passport issues just before international assignments or deployments. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Evergreen Way or at Everett Mall sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Snohomish County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Everett and Lynnwood Post Office appointments fill during summer and military deployment periods. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating I-5 Traffic to Seattle",
      description: "Many Everett residents attempt to drive to the Seattle passport agency in an emergency. I-5 traffic between Everett and Seattle can take 45–90+ minutes depending on the time of day — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Boeing international travel is year-round and Navy deployments can come with short notice — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Everett area or Snohomish County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Everett, Lynnwood, or Marysville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to battle I-5 traffic yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Everett address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Everett, WA?", a: "Fast Passport Center offers emergency passport processing in Everett, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — approximately 30 minutes south via I-5." },
    { q: "Does Everett have its own passport agency?", a: "No — Everett does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 30 minutes south via I-5). Fast Passport Center's courier service means Everett residents never need to deal with I-5 traffic and downtown Seattle parking." },
    { q: "Can I get an expedited passport in Lynnwood, Marysville, or Mukilteo?", a: "Absolutely. Fast Passport Center serves all of Snohomish County including Lynnwood, Marysville, Mukilteo, Mill Creek, Edmonds, Lake Stevens, and Monroe. Our service works the same way everywhere." },
    { q: "What airport do Everett travelers use for international flights?", a: "Paine Field (PAE) is Everett's own airport with commercial service via Alaska Airlines and United to select domestic destinations. For international travel, Seattle-Tacoma International Airport (SEA) is the primary airport for Snohomish County — approximately 35–45 minutes south via I-5. SEA offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations." },
    { q: "Does Fast Passport Center serve Naval Station Everett?", a: "Yes. Fast Passport Center serves all of Snohomish County including Naval Station Everett sailors and their families. We understand military deployment schedules and can accommodate urgent PCS and TDY travel needs. Our courier service is especially valuable for service members stationed at NS Everett." },
    { q: "How much does an expedited passport cost in Everett, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Everett?", a: "Walgreens, CVS, and Rite Aid stores throughout Everett and Lynnwood offer passport photos. UPS Store and FedEx Office locations also provide them. Many locations on Evergreen Way and at Everett Mall offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Boeing Everett Factory employees?", a: "Yes. Fast Passport Center serves all of Snohomish County including Boeing employees at the Everett Factory — the largest building in the world. We understand aerospace industry travel schedules and can accommodate urgent international assignments. Our courier service means Boeing workers don't need to take a day off to travel to Seattle." },
  ],
  photoLocations: [
    { name: "Walgreens — Evergreen Way", address: "6207 Evergreen Way, Everett, WA 98203", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "Rite Aid — Everett Mall", address: "10103 Evergreen Way, Everett, WA 98204", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "UPS Store — Downtown Everett", address: "2829 Colby Ave, Everett, WA 98201", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Lynnwood", address: "19620 Hwy 99, Lynnwood, WA 98036", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "WA DOL — Everett", address: "5010 172nd St NE, Arlington, WA 98223", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended. Located near Smokey Point, serving north Snohomish County.", featured: true },
    { name: "WA DOL — Lynnwood", address: "18023 Hwy 99, Lynnwood, WA 98037", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Lynnwood and south Everett area. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "PAE",
      name: "Paine Field — Snohomish County Airport",
      distance: "10 minutes from downtown Everett",
      address: "3220 100th St SW, Everett, WA 98204",
      note: "Everett's own commercial airport with service from Alaska Airlines and United to select domestic destinations including Las Vegas, Phoenix, Denver, and California cities. Home to the Boeing Everett Factory and a major aviation hub for Snohomish County.",
      flightUrl: "https://www.painefield.com/",
      flightLabel: "PAE Flight Info",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "35–45 minutes south of Everett via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary international airport for Snohomish County travelers. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Asia-Pacific gateway with direct flights to Tokyo, Seoul, Beijing, and Singapore.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: false,
    },
    {
      code: "BLI",
      name: "Bellingham International Airport",
      distance: "Approximately 60 minutes north of Everett via I-5",
      address: "4255 Mitchell Way, Bellingham, WA 98226",
      note: "Alternative airport for north Snohomish County residents. Seasonal flights to select destinations. Alaska Airlines serves BLI with connections through Seattle.",
      flightUrl: "https://www.portofbellingham.com/",
      flightLabel: "BLI Flight Info",
      featured: false,
    },
  ],
};